import React, { useState } from "react";
import TitleSection from "../components/TitleSection/TitleSection";
import DescriptionBox from "../components/DescriptionBox";
import ContactFormPages from "../components/ContactFormPages";
import { Images } from "../assets";
import { useTranslation } from "react-i18next";

const Realisations = () => {
  const { t } = useTranslation();

  const description = [t("rd.description1")];

  const listDescription = [
    t("rd.listDescription1"),
    t("rd.listDescription2"),
    t("rd.listDescription3"),
    t("rd.listDescription4"),
  ];

  const allProjects = [
    {
      title: t("rd.project1.title"),
      subtitle: t("rd.project1.subtitle"),
      images: [
        Images.PROJECT1_PICTURE1,
        Images.PROJECT1_PICTURE2,
        Images.PROJECT1_PICTURE3,
      ],
      description: [
        t("rd.project1.description1"),
        t("rd.project1.description2"),
      ],
      invert: false,
    },
    {
      title: t("rd.project2.title"),
      subtitle: t("rd.project2.subtitle"),
      images: [
        Images.PROJECT2_PICTURE1,
        Images.PROJECT2_PICTURE2,
        Images.PROJECT2_PICTURE3,
      ],
      description: [
        t("rd.project2.description1"),
        t("rd.project2.description2"),
      ],
      invert: true,
    },
    {
      title: t("rd.project3.title"),
      subtitle: t("rd.project3.subtitle"),
      images: [
        Images.PROJECT3_PICTURE1,
        Images.PROJECT3_PICTURE2,
        Images.PROJECT3_PICTURE3,
      ],
      description: [
        t("rd.project3.description1"),
        t("rd.project3.description2"),
      ],
      invert: false,
    },
    {
      title: t("rd.project4.title"),
      subtitle: t("rd.project4.subtitle"),
      images: [
        Images.PROJECT4_PICTURE1,
        Images.PROJECT4_PICTURE2,
        Images.PROJECT4_PICTURE3,
      ],
      description: [
        t("rd.project4.description1"),
        t("rd.project4.description2"),
      ],
      invert: true,
    },
  ];

  const [visibleProjects, setVisibleProjects] = useState(2);

  const handleLoadMore = () => {
    setVisibleProjects((prev) => prev + 2);
  };

  const handleLoadLess = () => {
    setVisibleProjects(2);
  };

  const ImageGrid = ({ images }) => {
    return (
      <div className="grid grid-cols-2 grid-rows-2 gap-5 w-full h-full max-h-[40vh] md:max-h-auto">
        {/* Top image */}
        <div className="col-span-2 overflow-hidden rounded-xl">
          <img
            src={images[0]}
            alt="Grille 1"
            className="w-full h-full object-cover block"
          />
        </div>

        {/* Bottom two */}
        <div className="overflow-hidden rounded-xl">
          <img
            src={images[1]}
            alt="Grille 2"
            className="w-full h-full object-cover block"
          />
        </div>
        <div className="overflow-hidden rounded-xl">
          <img
            src={images[2]}
            alt="Grille 3"
            className="w-full h-full object-cover block"
          />
        </div>
      </div>
    );
  };

  const Project = ({
    title = "Nom du projet",
    subtitle = "Sous-titre du projet",
    images = [],
    description = [],
    invert = false,
  }) => {
    return (
      <div
        className={`flex flex-col md:flex-row items-stretch justify-between gap-5 ${
          invert ? "md:flex-row-reverse" : "md:flex-row"
        } h-auto md:h-[30vh]`}
      >
        <div className="w-full md:w-2/5 h-full">
          <ImageGrid images={images} />
        </div>
        <div
          className={`flex flex-col items-start justify-center rounded-xl px-5 py-5 w-full md:w-3/5 h-full ${
            invert ? "bg-orange" : "bg-transparent border border-orange"
          }`}
        >
          <h3 className="font-title text-2xl text-start tracking-wider mb-2 md:mb-0">
            {title}
          </h3>
          <h4 className="font-title text-start mb-5">{subtitle}</h4>
          <div className="space-y-2 text-start md:text-justify">
            {description.map((paragraph, index) => (
              <p key={index}>{paragraph}</p>
            ))}
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <TitleSection
        title={t("rd.title")}
        subtitle={t("rd.subtitle")}
        highlightWords={[
          t("rd.highlightWords1"),
          t("rd.highlightWords2"),
          t("rd.highlightWords3"),
          t("rd.highlightWords4"),
        ]}
        bgImg={Images.RD_BG_IMAGE}
      />

      <div className="flex flex-col mx-5 md:mx-10 my-10">
        <section className="flex flex-col md:flex-row gap-5">
          <DescriptionBox
            title={t("rd.descriptionTitle")}
            content={description}
            list={listDescription}
          />
          <div className="w-full md:w-2/3">
            <img
              src={Images.RD_1}
              alt="Recherche et Développement"
              className="rounded-lg w-full h-full object-cover"
            />
          </div>
        </section>

        {/* Projects */}
        <section className="mt-32">
          <h2 className="font-title text-3xl md:text-4xl text-start mb-10">
            {t("rd.projectsTitle")}{" "}
            <span className="text-orange">{t("rd.projectsHighlight")}</span>
          </h2>
          <div className="flex flex-col gap-28 md:gap-20">
            {allProjects.slice(0, visibleProjects).map((project, index) => (
              <Project key={index} {...project} />
            ))}
          </div>
        </section>

        {/* Load more button */}
        {visibleProjects < allProjects.length ? (
          <button
            className="flex items-center gap-3 mx-auto text-2xl mt-14 mb-16 py-3 text-white"
            onClick={handleLoadMore}
          >
            {t("rd.loadMore")} <img src={Images.VIEW_MORE} alt="Voir plus" />
          </button>
        ) : (
          <button
            className="flex items-center gap-3 mx-auto text-2xl mt-14 mb-16 py-3 text-white"
            onClick={handleLoadLess}
          >
            {t("rd.loadLess")}{" "}
            <img
              src={Images.VIEW_MORE}
              alt="Voir plus"
              className="transform rotate-180"
            />
          </button>
        )}
      </div>

      <ContactFormPages />
    </>
  );
};

export default Realisations;
